<template>
  <v-row class="unauthorized-split-display">
    <v-col lg="6" class="bg-polygon">
      <img
        src="https://user-images.githubusercontent.com/46636890/145160915-3f87ab37-3636-4c5e-a1ba-102951bb4058.png"
      />
      <div class="transparent-wrapper">
        <h1>Journal of Materials & Environmental Sustainability Research</h1>
        <h2 class="mb-5">Manuscript Submission System</h2>
        <v-btn :href="journalURL" color="white" large>
          Visit Journal Homepage
        </v-btn>
      </div>
    </v-col>
    <v-col>
      <v-card max-width="510px" class="login-wrapper">
        <div class="pa-5 d-flex align-items-center">
          <v-spacer></v-spacer>
          <v-img
            class="shrink mr-2"
            contain
            src="https://www.iceesr.org.ng/favicon.png"
            transition="scale-transition"
            width="46"
          />
        </div>
        <h3 class="py-1 text-center green accent-4 white--text text-uppercase">
          New Registration
        </h3>
        <v-card class="px-5 py-8" color="basil" flat>
          <v-form class="mr-2 mt-4" v-model="valid" @submit.prevent="register">
            <v-row>
              <v-col cols="5">
                <v-select
                  :items="titles"
                  outlined
                  label="Title *"
                  prepend-icon="mdi-account-outline"
                  :rules="rules.required"
                  v-model="account.title"
                  validate-on-blur
                ></v-select>
              </v-col>
              <v-col cols="7">
                <v-text-field
                  outlined
                  label="First Name *"
                  :rules="rules.required"
                  v-model="account.firstName"
                  validate-on-blur
                ></v-text-field>
              </v-col>
            </v-row>

            <v-text-field
              outlined
              label="Last Name *"
              prepend-icon="mdi-account-group-outline"
              :rules="rules.required"
              v-model="account.lastName"
              validate-on-blur
            ></v-text-field>

            <v-combobox
              v-model="account.institution"
              :items="institutions"
              item-text="name"
              item-value="name"
              label="Institution name *"
              prepend-icon="mdi-school-outline"
              outlined
              :return-object="false"
              :rules="rules.required"
              validate-on-blur
            ></v-combobox>

            <v-text-field
              outlined
              validate-on-blur
              label="Department / College *"
              prepend-icon="mdi-office-building-outline"
              :rules="rules.required"
              v-model="account.department"
            ></v-text-field>

            <v-text-field
              outlined
              label="Specialization (optional)"
              prepend-icon="mdi-star"
              validate-on-blur
              v-model="account.specialization"
            ></v-text-field>

            <v-divider class="mt-3 mb-10"></v-divider>

            <v-text-field
              outlined
              label="Email *"
              validate-on-blur
              prepend-icon="mdi-at"
              :rules="rules.required"
              v-model="account.email"
            ></v-text-field>

            <v-text-field
              outlined
              label="Phone number (optional)"
              prepend-icon="mdi-phone"
              v-model="account.phone"
            ></v-text-field>

            <v-text-field
              outlined
              validate-on-blur
              label="Password *"
              prepend-icon="mdi-lock-outline"
              :rules="[...rules.required, ...rules.password]"
              v-model="account.password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>

            <v-text-field
              label="Confirm Password *"
              v-model="confirm"
              prepend-icon="mdi-shield-key-outline"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              outlined
              :rules="[
                (value) =>
                  value == account.password || 'Must be the same as  password',
              ]"
            ></v-text-field>

            <div class="ml-8">
              <p class="mb-7">* mark required fields.</p>
              <v-btn
                color="green"
                type="submit"
                class="white--text mr-2"
                :disabled="!valid || registering || account.password != confirm"
                :loading="registering"
              >
                Register
              </v-btn>
              <v-btn color="green" text to="/login"> Login Instead </v-btn>
            </div>
          </v-form>
        </v-card>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { required, password } from "../../tools/rules";
import { USER_TITLES } from "../../tools/specs";
import Institutions from "../../data/world_universities_and_domains-min.json";

export default {
  data: () => ({
    valid: false,
    showPassword: false,
    rules: {
      required,
      password,
    },

    email: null,
    password: null,
    registering: false,
    confirm: null,

    account: {
      title: "",
      firstName: "",
      lastName: "",
      institution: "",
      department: "",
      specialization: null,
      email: "",
      phone: "",
      password: "",
    },

    titles: USER_TITLES,
    institutions: Institutions,
    journalURL: process.env.VUE_APP_JOURNAL_URL,
  }),

  methods: {
    register() {
      this.registering = true;
      this.$axios
        .post("/register", {
          ...this.account,
          ...{ email: String(this.account.email).trim() },
        })
        .then(() => {
          this.$bus.$emit("snackbar", {
            type: "success",
            message: "Registration successful",
          });

          this.$router.push({ name: "login" });
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not register, email may already exist",
          });
        })
        .finally(() => {
          this.registering = false;
        });
    },
  },
};
</script>

<style lang="scss">
.unauthorized-split-display {
  background: #2a8414;
  min-height: 100vh;
  background-image: url("/images/polygon.svg");
  background-image: url("https://cdn.pixabay.com/photo/2014/12/15/16/57/tree-569275_960_720.jpg");
  background-position: center;
  background-size: cover;
  background-attachment: fixed;

  .bg-polygon {
    // background: #2a8414;
    min-height: 100vh;
    // background-image: url("/images/polygon.svg");
    // background-image: url("https://cdn.pixabay.com/photo/2014/12/15/16/57/tree-569275_960_720.jpg");
    // background-position: center;
    // background-size: cover;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    padding: 2em;
    text-align: center;

    position: fixed;

    .transparent-wrapper {
      background: hsl(0 0% 0% /0.3);
      padding: 2.5em 1em;
      margin: 2em 1em 1.5em;
    }

    @supports (backdrop-filter: blur(1.25rem)) {
      .transparent-wrapper {
        background: hsl(0 0% 0% /0.1);
        backdrop-filter: blur(1.25rem);
      }
    }

    img {
      width: 30%;
    }

    h1 {
      line-height: 1.2;
      color: #030805;
      color: #ffffff;
      // color: #6af54e;
      font-size: 2em;
      font-weight: 100;
      // text-shadow: 2px 2px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000,
      //   -1px 1px 0 #000, 1px 1px 0 #000;
    }

    h2 {
      color: #fefefe;
      color: #c6fdb8;
      letter-spacing: 1px;
      margin: 2rem 0 1.5rem;
      text-transform: uppercase;
    }
  }

  .container {
    z-index: 2;
    position: relative;
    margin: 8vh auto auto;
  }

  .login-wrapper {
    margin: 8% 10% 5% auto;
    // margin: 8% 12% 5% auto;
  }
}

@media screen and (max-width: 480px) {
  .unauthorized-split-display {
    .container {
      margin: 5% auto auto;
    }

    .bg-polygon {
      min-height: 100%;

      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      padding: 1.5em 1em 1em;
      text-align: center;

      position: relative;

      .transparent-wrapper {
        padding: 0 0.5em 1.5em;
        // margin: 1em;
        // background: transparent;
      }

      img {
        width: 45%;
        display: block;
        margin-top: 1.5em;
      }

      h1 {
        color: #ffffff;
        font-size: 2em;
        display: none;
      }

      h2 {
        font-style: #ffffff;
        font-size: 1.33rem;
        line-height: 1.3;
        padding: 0 1.5em 0;
      }
    }

    .login-wrapper {
      margin: 0 0.75em 10%;
    }
  }
}
</style>